export { default as ProfileEmailIcon } from './mail.svg';
export { default as ProfilePhoneIcon } from './phone.svg';
export { default as ProfileCameraIcon } from './camera.svg';
export { default as Copy } from './copy.svg';
export { default as Share } from './share.svg';
export { default as BlinkingHeartIcon } from './blinking-heart.svg';
export { default as HeartIcon } from './heart.svg';
